import React, { useEffect, useState } from 'react';
import apis from '../../utils/apis';
import httpAction from '../../utils/httpAction';
import CustomFileUploader from '../../components/common/CustomFileUploader';
import { resolveMedia } from '../../utils/media';
import { CardSkeleton, SkeletonText } from '../../components/common/Skeleton';

const fieldStyle = { width:'100%', padding:12, border:'1px solid #d0d5dd', borderRadius:10 };

export default function Partners() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [partners, setPartners] = useState([]);

  const loadData = async () => {
    setLoading(true);
    const result = await httpAction({ url: apis().publicSettings, silent: true });
    if (result?.status) {
      const s = result.settings || {};
      setTitle(s.partnersTitle || 'Companies & Developers We Work With');
      setDescription(s.partnersDescription || '');
      setPartners((s.partners || []).map((item, index) => ({
        _id: item._id || `p-${index}`,
        name: item.name || '',
        website: item.website || '',
        logoItems: item.logo ? [{ id:item.logo, url:item.logo, source:'server' }] : [],
      })));
    }
    setLoading(false);
  };

  useEffect(() => { loadData(); }, []);

  const addRow = () => setPartners((prev) => [...prev, { _id: `new-${Date.now()}`, name:'', website:'', logoItems:[] }]);
  const updateRow = (id, patch) => setPartners((prev) => prev.map((item) => item._id === id ? { ...item, ...patch } : item));
  const removeRow = (id) => setPartners((prev) => prev.filter((item) => item._id !== id));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const payload = {
      partnersTitle: title,
      partnersDescription: description,
      partners: partners.map((item) => ({ name:item.name, website:item.website, logo:item.logoItems?.[0]?.url || '' })).filter((item) => item.name || item.logo),
    };
    const result = await httpAction({ url: apis().updateSettings, method:'PUT', body: payload });
    setSaving(false);
    if (result?.status) loadData();
  };

  if (loading) return <div><SkeletonText width="210px" height={28} /><div style={{ marginTop:18 }}><CardSkeleton count={4} height={220} /></div></div>;

  return (
    <form onSubmit={submit} style={{ display:'grid', gap:18 }}>
      <div>
        <h2 style={{ margin:0 }}>Partners CMS</h2>
        <p style={{ color:'#667085' }}>Add or remove partner logos with real uploads instead of external image URLs.</p>
      </div>
      <div style={{ background:'#fff', borderRadius:18, padding:18, display:'grid', gap:12 }}>
        <input style={fieldStyle} value={title} onChange={(e)=>setTitle(e.target.value)} placeholder="Partners section title" />
        <textarea rows="3" style={fieldStyle} value={description} onChange={(e)=>setDescription(e.target.value)} placeholder="Partners section description" />
      </div>
      <div style={{ display:'grid', gap:18, gridTemplateColumns:'repeat(auto-fit,minmax(280px,1fr))' }}>
        {partners.map((item) => (
          <div key={item._id} style={{ background:'#fff', borderRadius:18, padding:18 }}>
            <input style={fieldStyle} value={item.name} onChange={(e)=>updateRow(item._id, { name:e.target.value })} placeholder="Partner name" />
            <input style={{ ...fieldStyle, marginTop:12 }} value={item.website} onChange={(e)=>updateRow(item._id, { website:e.target.value })} placeholder="Website URL" />
            <div style={{ marginTop:12 }}><CustomFileUploader multiple={false} onEdit={item.logoItems} onChange={(logoItems)=>updateRow(item._id, { logoItems })} /></div>
            <img src={resolveMedia(item.logoItems?.[0]?.url)} alt={item.name || 'Partner'} style={{ width:'100%', height:140, objectFit:'contain', background:'#f8fafc', borderRadius:14, marginTop:12 }} />
            <button type="button" onClick={() => removeRow(item._id)} style={{ marginTop:12, padding:'10px 14px', borderRadius:10, border:'1px solid #e4e7ec', color:'#b42318', background:'#fff' }}>Remove</button>
          </div>
        ))}
      </div>
      <div style={{ display:'flex', gap:12 }}>
        <button type="button" onClick={addRow} style={{ padding:'14px 18px', borderRadius:12, border:'1px solid #d0d5dd' }}>Add Partner</button>
        <button type="submit" disabled={saving} style={{ padding:'14px 22px', border:'none', borderRadius:12, background:'#0f5ef7', color:'#fff', fontWeight:700 }}>{saving ? 'Saving...' : 'Save Partners'}</button>
      </div>
    </form>
  );
}
